import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Permission, Role } from './role.model';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
    // allPermissions: Permission[];

    constructor(private _httpClient: HttpClient) { }


    getRole(id: number): Observable<Role>{
        return this._httpClient.get<Role>('/ypm/api/fm/role/' + id);
    }

    getAllPermissions(): Observable<Permission[]>{
        return this._httpClient.get<Permission[]>('/ypm/api/fm/permission');
    }

    guardarRole(role: Role): Observable<Role>{
        return this._httpClient.post<Role>('/ypm/api/fm/role' , role);
    }

}
